// (()=>{var e=()=>{var t,a,s,e=document.querySelector(".shopify-section-header"),r=e.querySelector(".list-menu--inline"),n=e.querySelectorAll(".list-menu-item"),i=e.querySelectorAll(".header__submenu");(t=e)&&t.classList.contains("color-background-overlay")&&(t.addEventListener("mouseenter",()=>{t.classList.remove("color-background-overlay"),t.classList.add("color-background-overlay-hidden")}),t.addEventListener("mouseleave",()=>{var e=document.querySelector("details-modal.header__search > details"),s=document.querySelector("burger-menu .burger-menu");e&&e.hasAttribute("open")||s&&s.classList.contains("burger-menu--open")||(t.classList.add("color-background-overlay"),t.classList.remove("color-background-overlay-hidden"))})),(a=n).forEach(s=>{s.addEventListener("mouseenter",e=>{s.classList.contains("list-menu--megamenu")?(s.classList.add("list-menu--megamenu-visible"),a.forEach(e=>{e!==s&&e.classList.remove("list-menu--megamenu-visible")})):a.forEach(e=>{e.classList.remove("list-menu--megamenu-visible")})}),s.addEventListener("focus",e=>{s.classList.contains("list-menu--megamenu")?(s.classList.add("list-menu--megamenu-visible"),a.forEach(e=>{e!==s&&e.classList.remove("list-menu--megamenu-visible")})):a.forEach(e=>{e.classList.remove("list-menu--megamenu-visible")})})}),s=n,(e=r)?.addEventListener("mouseleave",e=>{s.forEach(e=>{e.classList.remove("list-menu--megamenu-visible")}),document.querySelectorAll(".header__submenu-item").forEach(e=>{e.classList.remove("header__submenu-item--inactive")})}),e?.addEventListener("focusout",e=>{s.forEach(e=>{e.classList.remove("list-menu--megamenu-visible")})}),i.forEach(e=>{let a=e.querySelectorAll(".header__submenu-item:not(.header__submenu-item--grandchild)");a.forEach(s=>{let t=s.parentElement.querySelectorAll(".header__submenu-item--grandchild");s.addEventListener("mouseenter",e=>{a.forEach(e=>{e.classList.add("header__submenu-item--inactive")}),s.classList.remove("header__submenu-item--inactive")}),t.forEach(s=>{s.addEventListener("mouseenter",e=>{t.forEach(e=>{e.classList.add("header__submenu-item--inactive")}),s.classList.remove("header__submenu-item--inactive")})}),s.addEventListener("mouseleave",e=>{t.forEach(e=>{e.classList.remove("header__submenu-item--inactive")})})}),e.addEventListener("mouseleave",e=>{a.forEach(e=>{e.classList.remove("header__submenu-item--inactive")})})}),(()=>{var e=document.querySelector(".menu-drawer__close-button");let s=document.querySelector("header-drawer");e?.addEventListener("click",e=>{s&&customElements.get("header-drawer")&&s.closeMenuDrawer(e)})})()};document.addEventListener("shopify:section:load",e),document.addEventListener("shopify:section:unload",e),document.addEventListener("shopify:section:reorder",e),e()})();





(() => {
    var e = () => {
        var t, a, s, e = document.querySelector(".shopify-section-header"),
            r = e.querySelector(".list-menu--inline"),
            n = e.querySelectorAll(".list-menu-item"),
            i = e.querySelectorAll(".header__submenu");
        (t = e) && t.classList.contains("color-background-overlay") && (t.addEventListener("mouseenter", () => {
            t.classList.remove("color-background-overlay"), t.classList.add("color-background-overlay-hidden")
        }), t.addEventListener("mouseleave", () => {
            var e = document.querySelector("details-modal.header__search > details"),
                s = document.querySelector("burger-menu .burger-menu");
            e && e.hasAttribute("open") || s && s.classList.contains("burger-menu--open") || (t.classList.add("color-background-overlay"), t.classList.remove("color-background-overlay-hidden"))
        })), (a = n).forEach(s => {
            s.addEventListener("mouseenter", e => {
                s.classList.contains("list-menu--megamenu") ? (s.classList.add("list-menu--megamenu-visible"), a.forEach(e => {
                    e !== s && e.classList.remove("list-menu--megamenu-visible")
                })) : a.forEach(e => {
                    e.classList.remove("list-menu--megamenu-visible")
                })
            }), s.addEventListener("focus", e => {
                s.classList.contains("list-menu--megamenu") ? (s.classList.add("list-menu--megamenu-visible"), a.forEach(e => {
                    e !== s && e.classList.remove("list-menu--megamenu-visible")
                })) : a.forEach(e => {
                    e.classList.remove("list-menu--megamenu-visible")
                })
            })
        }), s = n, (e = r)?.addEventListener("mouseleave", e => {
            s.forEach(e => {
                e.classList.remove("list-menu--megamenu-visible")
            }), document.querySelectorAll(".header__submenu-item").forEach(e => {
                e.classList.remove("header__submenu-item--inactive")
            })
        }), e?.addEventListener("focusout", e => {
            s.forEach(e => {
                e.classList.remove("list-menu--megamenu-visible")
            })
        }), i.forEach(e => {
            let a = e.querySelectorAll(".header__submenu-item:not(.header__submenu-item--grandchild)");
            a.forEach(s => {
                let t = s.parentElement.querySelectorAll(".header__submenu-item--grandchild");
                s.addEventListener("mouseenter", e => {
                    a.forEach(e => {
                        e.classList.add("header__submenu-item--inactive")
                    }), s.classList.remove("header__submenu-item--inactive")
                }), t.forEach(s => {
                    s.addEventListener("mouseenter", e => {
                        t.forEach(e => {
                            e.classList.add("header__submenu-item--inactive")
                        }), s.classList.remove("header__submenu-item--inactive")
                    })
                }), s.addEventListener("mouseleave", e => {
                    t.forEach(e => {
                        e.classList.remove("header__submenu-item--inactive")
                    })
                })
            }), e.addEventListener("mouseleave", e => {
                a.forEach(e => {
                    e.classList.remove("header__submenu-item--inactive")
                })
            })
        }), (() => {
            var e = document.querySelector(".menu-drawer__close-button");
            let s = document.querySelector("header-drawer");
            e?.addEventListener("click", e => {
                s && customElements.get("header-drawer") && s.closeMenuDrawer(e)
            })
        })()
    };
    document.addEventListener("shopify:section:load", e), document.addEventListener("shopify:section:unload", e), document.addEventListener("shopify:section:reorder", e), e()
})();


//AK custom code
document.querySelectorAll(".list-menu li").forEach((item) => {
  let hideTimeout;

  item.addEventListener("mouseenter", () => {
    clearTimeout(hideTimeout);
    item.classList.add("list-menu--megamenu-visible");
  });

  item.addEventListener("mouseleave", () => {
    hideTimeout = setTimeout(() => {
      item.classList.remove("list-menu--megamenu-visible");
    }, 200); // adjust delay
  });
});
//AK custom code
